"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COUNTRY_LIST_SELECT = exports.COUNTRY_LANGUAGE_LIST = void 0;
exports.COUNTRY_LANGUAGE_LIST = [
    {
        countryName: 'United Arab Emirates',
        id: 'AE',
        isoCode: 'AE',
        supportedLanguages: [
            {
                id: 'en',
                isoCode: 'en',
                languageName: 'English (UAE)'
            }
        ]
    },
    {
        countryName: 'Argentina',
        id: 'AR',
        isoCode: 'AR',
        supportedLanguages: [
            {
                id: 'es',
                isoCode: 'es',
                languageName: 'Spanish (Argentina)'
            }
        ]
    },
    {
        countryName: 'Austria',
        id: 'AT',
        isoCode: 'AT',
        supportedLanguages: [
            {
                id: 'de',
                isoCode: 'de',
                languageName: 'German (Austrian)'
            }
        ]
    },
    {
        countryName: 'Australia',
        id: 'AU',
        isoCode: 'AU',
        supportedLanguages: [
            {
                id: 'en',
                isoCode: 'en',
                languageName: 'English (Australian)'
            }
        ]
    },
    {
        countryName: 'Belgium',
        id: 'BE',
        isoCode: 'BE',
        supportedLanguages: [
            {
                id: 'nl',
                isoCode: 'nl',
                languageName: 'Dutch (belgian)'
            },
            {
                id: 'fr',
                isoCode: 'fr',
                languageName: 'French (Belgian)'
            }
        ]
    },
    {
        countryName: 'Bulgaria',
        id: 'BG',
        isoCode: 'BG',
        supportedLanguages: [
            {
                id: 'bg',
                isoCode: 'bg',
                languageName: 'Bulgarian'
            }
        ]
    },
    {
        countryName: 'Bahrain',
        id: 'BH',
        isoCode: 'BH',
        supportedLanguages: [
            {
                id: 'en',
                isoCode: 'en',
                languageName: 'English (Bahrain)'
            }
        ]
    },
    {
        countryName: 'Brazil',
        id: 'BR',
        isoCode: 'BR',
        supportedLanguages: [
            {
                id: 'pt',
                isoCode: 'pt',
                languageName: 'Portugese (Brazilian)'
            }
        ]
    },
    {
        countryName: 'Canada',
        id: 'CA',
        isoCode: 'CA',
        supportedLanguages: [
            {
                id: 'en',
                isoCode: 'en',
                languageName: 'English (CA)'
            },
            {
                id: 'fr',
                isoCode: 'fr',
                languageName: 'French (CA)'
            }
        ]
    },
    {
        countryName: 'Switzerland',
        id: 'CH',
        isoCode: 'CH',
        supportedLanguages: [
            {
                id: 'en',
                isoCode: 'en',
                languageName: 'English (Swiss)'
            },
            {
                id: 'fr',
                isoCode: 'fr',
                languageName: 'French (Swiss)'
            },
            {
                id: 'de',
                isoCode: 'de',
                languageName: 'German (Swiss)'
            },
            {
                id: 'it',
                isoCode: 'it',
                languageName: 'Italian (Swiss)'
            }
        ]
    },
    {
        countryName: 'Chile',
        id: 'CL',
        isoCode: 'CL',
        supportedLanguages: [
            {
                id: 'es',
                isoCode: 'es',
                languageName: 'Spanish (Chile)'
            }
        ]
    },
    {
        countryName: 'China',
        id: 'CN',
        isoCode: 'CN',
        supportedLanguages: [
            {
                id: 'zh',
                isoCode: 'zh',
                languageName: 'Chinese (PRC)'
            }
        ]
    },
    {
        countryName: 'Colombia',
        id: 'CO',
        isoCode: 'CO',
        supportedLanguages: [
            {
                id: 'es',
                isoCode: 'es',
                languageName: 'Spanish (Colombia)'
            }
        ]
    },
    {
        countryName: 'Czech',
        id: 'CZ',
        isoCode: 'CZ',
        supportedLanguages: [
            {
                id: 'cs',
                isoCode: 'cs',
                languageName: 'Czech'
            }
        ]
    },
    {
        countryName: 'Germany',
        id: 'DE',
        isoCode: 'DE',
        supportedLanguages: [
            {
                id: 'de',
                isoCode: 'de',
                languageName: 'German'
            }
        ]
    },
    {
        countryName: 'Denmark',
        id: 'DK',
        isoCode: 'DK',
        supportedLanguages: [
            {
                id: 'da',
                isoCode: 'da',
                languageName: 'Danish'
            }
        ]
    },
    {
        countryName: 'Spain',
        id: 'ES',
        isoCode: 'ES',
        supportedLanguages: [
            {
                id: 'es',
                isoCode: 'es',
                languageName: 'Spanish'
            }
        ]
    },
    {
        countryName: 'Finland',
        id: 'FI',
        isoCode: 'FI',
        supportedLanguages: [
            {
                id: 'fi',
                isoCode: 'fi',
                languageName: 'Finnish'
            }
        ]
    },
    {
        countryName: 'United Kingdom',
        id: 'GB',
        isoCode: 'GB',
        supportedLanguages: [
            {
                id: 'en',
                isoCode: 'en',
                languageName: 'English (UK)'
            }
        ]
    },
    {
        countryName: 'Greece',
        id: 'GR',
        isoCode: 'GR',
        supportedLanguages: [
            {
                id: 'el',
                isoCode: 'el',
                languageName: 'Greek'
            }
        ]
    },
    {
        countryName: 'China Hongkong',
        id: 'HK',
        isoCode: 'HK',
        supportedLanguages: [
            {
                id: 'zh',
                isoCode: 'zh',
                languageName: 'Chinese (Hong Kong)'
            },
            {
                id: 'en',
                isoCode: 'en',
                languageName: 'English (Hong Kong)'
            }
        ]
    },
    {
        countryName: 'Hungary',
        id: 'HU',
        isoCode: 'HU',
        supportedLanguages: [
            {
                id: 'hu',
                isoCode: 'hu',
                languageName: 'Hungarian'
            }
        ]
    },
    {
        countryName: 'Indonesia',
        id: 'ID',
        isoCode: 'ID',
        supportedLanguages: [
            {
                id: 'en',
                isoCode: 'en',
                languageName: 'English (ID)'
            },
            {
                id: 'id',
                isoCode: 'id',
                languageName: 'Indonesian'
            }
        ]
    },
    {
        countryName: 'Ireland',
        id: 'IE',
        isoCode: 'IE',
        supportedLanguages: [
            {
                id: 'en',
                isoCode: 'en',
                languageName: 'English (Ireland)'
            }
        ]
    },
    {
        countryName: 'India',
        id: 'IN',
        isoCode: 'IN',
        supportedLanguages: [
            {
                id: 'bn',
                isoCode: 'bn',
                languageName: 'Bengali (India)'
            },
            {
                id: 'en',
                isoCode: 'en',
                languageName: 'English (India)'
            },
            {
                id: 'hi',
                isoCode: 'hi',
                languageName: 'Hindi (India)'
            },
            {
                id: 'kn',
                isoCode: 'kn',
                languageName: 'Kannada (India)'
            },
            {
                id: 'mr',
                isoCode: 'mr',
                languageName: 'Marathi (India)'
            },
            {
                id: 'ta',
                isoCode: 'ta',
                languageName: 'Tamil (India)'
            }
        ]
    },
    {
        countryName: 'Italy',
        id: 'IT',
        isoCode: 'IT',
        supportedLanguages: [
            {
                id: 'it',
                isoCode: 'it',
                languageName: 'Italian'
            }
        ]
    },
    {
        countryName: 'Japan',
        id: 'JP',
        isoCode: 'JP',
        supportedLanguages: [
            {
                id: 'ja',
                isoCode: 'ja',
                languageName: 'Japanese'
            }
        ]
    },
    {
        countryName: 'Korea, South',
        id: 'KR',
        isoCode: 'KR',
        supportedLanguages: [
            {
                id: 'ko',
                isoCode: 'ko',
                languageName: 'Korean'
            }
        ]
    },
    {
        countryName: 'Mexico',
        id: 'MX',
        isoCode: 'MX',
        supportedLanguages: [
            {
                id: 'es',
                isoCode: 'es',
                languageName: 'Spanish (Mexican)'
            }
        ]
    },
    {
        countryName: 'Malaysia',
        id: 'MY',
        isoCode: 'MY',
        supportedLanguages: [
            {
                id: 'en',
                isoCode: 'en',
                languageName: 'English (Malaysian)'
            },
            {
                id: 'ms',
                isoCode: 'ms',
                languageName: 'Malay (Malaycian)'
            }
        ]
    },
    {
        countryName: 'Netherlands',
        id: 'NL',
        isoCode: 'NL',
        supportedLanguages: [
            {
                id: 'nl',
                isoCode: 'nl',
                languageName: 'Dutch'
            }
        ]
    },
    {
        countryName: 'Norway',
        id: 'NO',
        isoCode: 'NO',
        supportedLanguages: [
            {
                id: 'nb',
                isoCode: 'nb',
                languageName: 'Norwegian'
            }
        ]
    },
    {
        countryName: 'New Zealand',
        id: 'NZ',
        isoCode: 'NZ',
        supportedLanguages: [
            {
                id: 'en',
                isoCode: 'en',
                languageName: 'English (New Zealand)'
            }
        ]
    },
    {
        countryName: 'Philippines',
        id: 'PH',
        isoCode: 'PH',
        supportedLanguages: [
            {
                id: 'en',
                isoCode: 'en',
                languageName: 'English (Philippines)'
            }
        ]
    },
    {
        countryName: 'Poland',
        id: 'PL',
        isoCode: 'PL',
        supportedLanguages: [
            {
                id: 'pl',
                isoCode: 'pl',
                languageName: 'Polish'
            }
        ]
    },
    {
        countryName: 'Portugal',
        id: 'PT',
        isoCode: 'PT',
        supportedLanguages: [
            {
                id: 'pt',
                isoCode: 'pt',
                languageName: 'Portugese (Portugal)'
            }
        ]
    },
    {
        countryName: 'Qatar',
        id: 'QA',
        isoCode: 'QA',
        supportedLanguages: [
            {
                id: 'en',
                isoCode: 'en',
                languageName: 'English (Qatar)'
            }
        ]
    },
    {
        countryName: 'Romania',
        id: 'RO',
        isoCode: 'RO',
        supportedLanguages: [
            {
                id: 'ro',
                isoCode: 'ro',
                languageName: 'Romanian'
            }
        ]
    },
    {
        countryName: 'Sweden',
        id: 'SE',
        isoCode: 'SE',
        supportedLanguages: [
            {
                id: 'sv',
                isoCode: 'sv',
                languageName: 'Swedish'
            }
        ]
    },
    {
        countryName: 'Singapore',
        id: 'SG',
        isoCode: 'SG',
        supportedLanguages: [
            {
                id: 'zh',
                isoCode: 'zh',
                languageName: 'Chinese (Singapore)'
            },
            {
                id: 'en',
                isoCode: 'en',
                languageName: 'English (Singapore)'
            }
        ]
    },
    {
        countryName: 'Slovakia',
        id: 'SK',
        isoCode: 'SK',
        supportedLanguages: [
            {
                id: 'sk',
                isoCode: 'sk',
                languageName: 'Slovak'
            }
        ]
    },
    {
        countryName: 'Thailand',
        id: 'TH',
        isoCode: 'TH',
        supportedLanguages: [
            {
                id: 'th',
                isoCode: 'th',
                languageName: 'Thai (Thailand)'
            }
        ]
    },
    {
        countryName: 'Turkey',
        id: 'TR',
        isoCode: 'TR',
        supportedLanguages: [
            {
                id: 'tr',
                isoCode: 'tr',
                languageName: 'Turkish (Turkey)'
            }
        ]
    },
    {
        countryName: 'Taiwan Region',
        id: 'TW',
        isoCode: 'TW',
        supportedLanguages: [
            {
                id: 'zh',
                isoCode: 'zh',
                languageName: 'Chinese (Taiwan)'
            }
        ]
    },
    {
        countryName: 'United States of America',
        id: 'US',
        isoCode: 'US',
        supportedLanguages: [
            {
                id: 'en',
                isoCode: 'en',
                languageName: 'English (US)'
            },
            {
                id: 'es',
                isoCode: 'es',
                languageName: 'Spanish (US)'
            }
        ]
    },
    {
        countryName: 'Vietnam',
        id: 'VN',
        isoCode: 'VN',
        supportedLanguages: [
            {
                id: 'vi',
                isoCode: 'vi',
                languageName: 'Vietnamese'
            }
        ]
    },
    {
        countryName: 'South Africa',
        id: 'ZA',
        isoCode: 'ZA',
        supportedLanguages: [
            {
                id: 'en',
                isoCode: 'en',
                languageName: 'English (South Africa)'
            }
        ]
    }
];
exports.COUNTRY_LIST_SELECT = exports.COUNTRY_LANGUAGE_LIST.map(function (country) { return ({
    label: country.countryName,
    value: country.isoCode
}); });
//# sourceMappingURL=countries.js.map